export default __webpack_public_path__ + "static/media/lesson_list.b09906e0.jpg";